import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { MediaPictureComponent } from "@hermes/aphrodite/media-picture";
import { EditorialCTAResolverModule } from "@hermes/fragments/editorial-cta-resolver";
import { TrustHtmlPipeModule } from "@hermes/utils-generic/pipes/trust-html";

import { CHAPTERS_COMPONENT } from "../../core";
import { AnimateOnScrollDirectiveModule } from "../../directives/animate-on-scroll/animate-on-scroll.module";

import { CategoryPosterAnalyticsService } from "./category-poster-analytics.service";
import { CategoryPosterComponent } from "./category-poster.component";

@NgModule({
    declarations: [CategoryPosterComponent],
    imports: [
        CommonModule,
        MediaPictureComponent,
        AnimateOnScrollDirectiveModule,
        EditorialCTAResolverModule,
        TrustHtmlPipeModule,
    ],
    providers: [
        {
            provide: CHAPTERS_COMPONENT,
            useValue: CategoryPosterComponent,
        },
        CategoryPosterAnalyticsService,
    ],
})
export class CategoryPosterModule {}
